





















































































import { ProductType } from "@/models/products/product";
import { Component, Prop, Mixins } from "vue-property-decorator";
import ConfirmNewQuote from "@/components/elements/modal/ConfirmNewQuote.vue";
import UIkit from "uikit";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions, OrderGetters } from "@/store/modules/order/types";
import { LineItem } from "@/models/order/order";
import { EventBus } from "@/event-bus";
import { Mobile } from "@/mixins/mobile";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import ContactUs from "@/components/elements/modal/ContactUs.vue";

@Component({
  components: {
    ConfirmNewQuote,
    ContactUs,
  },
})
export default class Menu extends Mixins(Mobile) {
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetRole))
  userRole!: string;
  @(namespace(StoreModule.Order).Action(OrderActions.ClearOrder))
  resetOrder!: () => Promise<void>;
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrderItems))
  items!: LineItem[];
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: number) => Promise<void>;
  protected type = ProductType;
  protected showContactUsModal = false;
  protected showNewQuoteModal = false;

  created(): void {
    EventBus.$on("createNewQuote", () => {
      this.toggleNewQuoteModal();
    });
  }

  beforeDestroy(): void {
    EventBus.$off("createNewQuote");
  }

  protected toggleNewQuoteModal(): void {
    if (this.items.length > 0) {
      // only toggling warning modal if there is an item associated with the order
      this.showNewQuoteModal = true;
    } else {
      this.clearOrder();
    }
  }

  protected closeNewQuoteModal(): void {
    this.showNewQuoteModal = false;
  }

  protected toggleContactUsModal() {
    this.showContactUsModal = true;
  }

  protected closeContactUsModal(): void {
    this.showContactUsModal = false;
  }

  protected async clearOrder(): Promise<void> {
    //this.handleToggle();
    this.closeNewQuoteModal();
    UIkit.offcanvas("#offcanvas-nav").hide();
    await this.resetOrder();
    await this.addMultiplier(1);

    if (this.$route.path !== "/collections/umbrella") {
      this.$router.push("/collections/umbrella");
    }
  }
}
